/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function HighlighterCircle(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M201.53906,54.46094A103.99994,103.99994,0,1,0,54.46094,201.53906,103.99994,103.99994,0,1,0,201.53906,54.46094ZM96,209.9989V152h64v57.9989a88.31824,88.31824,0,0,1-64,0Zm94.22461-19.77429A88.78305,88.78305,0,0,1,176,201.76886V152a16.01833,16.01833,0,0,0-16-16V72a8,8,0,0,0-11.57812-7.15527l-48,24A7.99967,7.99967,0,0,0,96,96v40a16.01833,16.01833,0,0,0-16,16v49.76886a88.78631,88.78631,0,0,1-14.22461-11.54425,88,88,0,1,1,124.44922,0Z" />
    </Svg>
  );
}

export default HighlighterCircle;
